import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex",
  style: {"width":"100%"}
}
const _hoisted_2 = { class: "flex secondgroup" }
const _hoisted_3 = { class: "flex flex-column reportperiod dropdown" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "periodOption",
  style: {"display":"block"}
}, "Period Option", -1)
const _hoisted_5 = { class: "flex flex-column start dropdown" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "startDate",
  style: {"display":"block"}
}, "Period Start", -1)
const _hoisted_7 = { class: "flex flex-column end dropdown" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "endDate",
  style: {"display":"block"}
}, "Period End", -1)

import { ref, onMounted } from 'vue';
import { setServicePackageSales } from '@/composables/useInputParameters';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  name: 'ServicePackageSales',
  setup(__props) {

onMounted(async () => {
    selectedPeriod.value = periods.value[2];
    setServicePackageSales(startDate.value, endDate.value);
});

const selectedPeriod = ref();
const periods = ref([
    { name: 'Today', code: 'today' },
    { name: 'This Week', code: 'tw' },
    { name: 'This Month', code: 'tm' },
    { name: 'This Quarter', code: 'tq' },
    { name: 'This Year', code: 'ty' },
    { name: 'Yesterday', code: 'yesterday' },
    { name: 'Last Week', code: 'lw' },
    { name: 'Last Month', code: 'lm' },
    { name: 'Last Quarter', code: 'lq' },
    { name: 'Last Year', code: 'ly' }
]);

const startDate = ref(moment().startOf('month').format('MM/DD/YYYY'));
const endDate = ref(moment().endOf('month').format('MM/DD/YYYY'));

const updateStartDate = () => {
    endDate.value = '';
}

const updateEndDate = async () => {
    startDate.value = moment(startDate.value).format('MM/DD/YYYY');
    endDate.value = moment(endDate.value).format('MM/DD/YYYY');
    setServicePackageSales(startDate.value, endDate.value);
}

const setPeriodDates = () => {
    const today = moment();
    let start, end;

    switch (selectedPeriod.value.code) {
      case 'today':
          start = end = today;
          break;
      case 'yesterday':
          start = end = today.subtract(1, 'day');
          break;
      case 'tw':
          start = today.clone().startOf('week');
          end = today.clone().endOf('week');
          break;
      case 'tm':
          start = today.clone().startOf('month');
          end = today.clone().endOf('month');
          break;
      case 'tq':
          start = today.clone().startOf('quarter');
          end = today.clone().endOf('quarter');
          break;
      case 'ty':
          start = today.clone().startOf('year');
          end = today.clone().endOf('year');
          break;
      case 'lw':
          start = today.clone().subtract(1, 'week').startOf('week');
          end = today.clone().subtract(1, 'week').endOf('week');
          break;
      case 'lm':
          start = today.clone().subtract(1, 'month').startOf('month');
          end = today.clone().subtract(1, 'month').endOf('month');
          break;
      case 'lq':
          start = today.clone().subtract(1, 'quarter').startOf('quarter');
          end = today.clone().subtract(1, 'quarter').endOf('quarter');
          break;
      case 'ly':
          start = today.clone().subtract(1, 'year').startOf('year');
          end = today.clone().subtract(1, 'year').endOf('year');
          break;
    }

    const startCalendarElement = document.getElementById('startDate')?.querySelector('input');
    const endCalendarElement = document.getElementById('endDate')?.querySelector('input');
    const startDateValue = moment(start.toDate()).format('MM/DD/YYYY');
    const endDateValue = moment(end.toDate()).format('MM/DD/YYYY');
    startCalendarElement.value = `${startDateValue}`;
    endCalendarElement.value = `${endDateValue}`;
    startDate.value = startDateValue;
    endDate.value = endDateValue;

    setServicePackageSales(startDate.value, endDate.value);
}

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Dropdown, {
          id: "periodOption",
          modelValue: selectedPeriod.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPeriod).value = $event)),
          options: periods.value,
          optionLabel: "name",
          placeholder: "Select Period",
          onChange: setPeriodDates,
          style: {"min-width":"10rem"}
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_Calendar, {
          id: "startDate",
          modelValue: startDate.value,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((startDate).value = $event)),
            updateStartDate
          ]
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_Calendar, {
          id: "endDate",
          modelValue: endDate.value,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => ((endDate).value = $event)),
            updateEndDate
          ]
        }, null, 8, ["modelValue"])
      ])
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})